import { AubadeComponent } from "js/front/bootstrap";
import { gsap } from 'gsap';
import { customization } from 'storage';

const zeroPad = (num, places) => String(num).padStart(places, '0')

export class Scene extends AubadeComponent{
	constructor(e, b){
		super(e, b);
		this.amounts = Array.from(this.element.querySelectorAll('.fps-estimation-amount'));

		this.scenePreview = document.querySelector("#scene-preview");
		this.editProduct  = document.querySelector("#edit-product");
		this.header =  this.bootstrap.components.get(document.querySelector("header"));
		this.data = this.element.dataset.data != "" ? JSON.parse(this.element.dataset.data) : null;
		if(this.data){
			this.data.uuid = null;
		}
		this.lastCustomization = null;

		window["scene"] = this;
	}

	init(){
		this.cScenePreview = this.components.get(this.scenePreview);
		this.cEditProduct  = this.components.get(this.editProduct);

		this.cAmounts = this.amounts.filter(amount => amount.dataset.component == "BanditManchot")
									.map(amount => this.components.get(amount));

	}

	attach() {
		this.viewport.on('resize', this.resize);

		this.cScenePreview.on('editview', this.enterEditView)
		this.cEditProduct.on('apply', this.enterScenePreview)
		this.cEditProduct.on('cancel', this.revertCustomization)

		customization.on('product-modified', this.updateAmounts);
		customization.on('product-added', this.updateAmounts);
		customization.on('product-removed', this.updateAmounts);
		customization.on('customization-loaded', this.updateAmounts);
	}

	detach() {
		this.viewport.off('resize', this.resize);

		this.cScenePreview.off('editview', this.enterEditView)
		this.cEditProduct.off('apply', this.enterScenePreview)
		this.cEditProduct.off('cancel', this.revertCustomization)

		customization.off('product-modified', this.updateAmounts);
		customization.off('product-added', this.updateAmounts);
		customization.off('product-removed', this.updateAmounts);
		customization.off('customization-loaded', this.updateAmounts);
	}

	open(){
		this.header.openHeaderNotHome();
		this.header.toggleOnSimulateur();
		if(this.data){
	        customization.load(this.data);
		}
		else customization.load({
			scene:this.element.dataset.scene
		})
		const t = gsap.timeline();
		t.add(this.cScenePreview.open());
		return t;
	}
	close(){
		this.header.toggleOnSimulateur();
		const t = gsap.timeline();
			t.add(this.cScenePreview.close(), 0);
			t.add(this.cEditProduct.close(), 0);
		return t;
	}

	resize = () => {
		this.element.style.height = this.viewport.height + 'px';
	}

	enterEditView = ({code, dependency}) => {
		this.lastCustomization = customization.getDatas();
		const t = gsap.timeline();
		t.add(this.cEditProduct.edit(code, dependency), 0)
		t.add(this.cScenePreview.hideUI(), 0)
		return t;
	}

	enterScenePreview = () => {
		this.cScenePreview.restoreView();
		const t = gsap.timeline();
		t.add(this.cEditProduct.close(), 0);
		t.add(this.cScenePreview.showUI(), 0)
		return t;
	}

	revertCustomization = () => {
		this.header.openHeaderNotHome();
		this.updateAmounts()
		customization.load(this.lastCustomization)
		this.enterScenePreview();
	}

	updateAmounts = () => {
		const amount = customization.formattedTotalPriceTTC;

		this.amount = amount;
	}

	set amount(amount){
		this.amounts.forEach(amnt => {
			if(amnt.dataset.component != "BanditManchot"){
				amnt.innerHTML = amount;
			}
		});
		this.cAmounts.forEach(am => am.value = amount);
	}
}
